import React, {Button, Component, useState } from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import _ from '../../utils/languages/languages';
import TextInput from "../../widgets/TextInput";
//import TimePicker from 'react-time-picker';
import GetCompany from '../../services/getCompany';
import ImageInput from "../../widgets/ImageInput";
import getIntermediaries from "../../services/getIntermediaries";

export default class EditCompanyBroker extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };
  
    this.section = this.props.section
    if (this.section == undefined){
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.userslist = [];

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: false,
      addElementVisible: false
    }

    this.grid = 2;

    this.pageTitle = "Company details";
    this.startDateRef = React.createRef();
    this.endDateRef = React.createRef();

    this.state = {

    };

  }


  async componentDidMount(){

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    const currentEventId = cookies.get('currentEventId', { path: '/' });
    const currentCompany = cookies.get('currentCompany', { path: '/' });

    this.company = await GetCompany(username, token, currentEventId, currentCompany);
    this.brokers = await getIntermediaries(username, token, currentEventId, 'company');

    this.brokerSelect = [];
    this.brokerSelected = [];
    this.brokers && this.brokers.forEach(b => {
      this.brokerSelect.push({ value: b.id, label: b.name });
      var brokersArray = this.company.broker_id.split(',');
      if (brokersArray.includes(b.id))
        this.brokerSelected.push ({ value: b.id, label: b.name });

      this.setState({
        brokers: this.brokerSelected
      })
    })

    this.setState({
      companyName: this.company.name,
      website: this.company.web_site,
      marketCap: this.company.market_cap,
      bloombergNumber: this.company.bloombergNumber,
      logo: this.company.logo,
      logo_simple: this.company.logo_simple,
      sector: this.company.sector,
      country: this.company.country,
      pdfProfile: this.company.pdf_profile,
      rapresentative: this.company.rapresentative,
      contactPerson: this.company.contact_person,
      phoneNumber: this.company.phone_number,
      mobileNumber: this.company.mobile_number,
      email: this.company.email_address,
      additionalMailAddress: this.company.second_email_address,
    });
  }

  render () {

    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={_.tr('Loading your content...')}
      >
        <PageTitle title={this.pageTitle} />
          
          <TextInput name={'Company name'} value={this.state.companyName} 
            onChange={(text) => { this.setState({companyName: text})}
          }
          readOnly={true}
          />


          <ImageInput name={'Logo'} key={Math.random()} 
            value={this.state.logo}
            readOnly={true}
            onChange={(val) =>           
              this.setState({logo: val})
              }
          />

          <ImageInput name={'Schedule\'s banner'} key={Math.random()} 
            value={this.state.logo_simple}
            readOnly={true}
            onChange={(val) =>           
              this.setState({logo_simple: val})
              }
          />

          <TextInput name={'Website'} value={this.state.website} 
          readOnly={true}
          onChange={(text) => { this.setState({website: text})}
          } />
          <TextInput name={'Market Cap'} value={this.state.marketCap} 
          readOnly={true}
          onChange={(text) => { this.setState({marketCap: text})}
          } />
          <TextInput name={'Bloomberg number'} value={this.state.bloombergNumber} 
          readOnly={true}
          onChange={(text) => { this.setState({bloombergNumber: text})}
          } />
          <TextInput name={'Sector'} value={this.state.sector} 
          readOnly={true}
          onChange={(text) => { this.setState({sector: text})}
          } />
          <TextInput name={'Country'} value={this.state.country} 
          readOnly={true}
          onChange={(text) => { this.setState({country: text})}
          } />
          <TextInput name={'Pdf Profile'} value={this.state.pdfProfile} 
          readOnly={true}
          onChange={(text) => { this.setState({pdfProfile: text})}
          } />
          <TextInput name={'Representatives (separated by ;)'} value={this.state.rapresentative} 
          readOnly={true}
          onChange={(text) => { this.setState({rapresentative: text})}
          } />
          <TextInput name={'Contact Person'} value={this.state.contactPerson} 
          readOnly={true}
          onChange={(text) => { this.setState({contactPerson: text})}
          } />
          <TextInput name={'Phone Number'} value={this.state.phoneNumber} 
          readOnly={true}
          onChange={(text) => { this.setState({phoneNumber: text})}
          } />
          <TextInput name={'Mobile Number'} value={this.state.mobileNumber} 
          readOnly={true}
          onChange={(text) => { this.setState({mobileNumber: text})}
          } />
          <TextInput name={'eMail Address'} value={this.state.email} 
          readOnly={true}
          onChange={(text) => { this.setState({email: text})}
          } />
          <TextInput name={'Additional eMail address'} value={this.state.additionalMailAddress} 
          readOnly={true}
          onChange={(text) => { this.setState({additionalMailAddress: text})}
          } />


        </LoadingOverlay>
      </>
    );
  }

}

